<div class="profile-containerxxxx">
  <!-- <p class="from2" >Actualización De Datos</p> -->
  <div class="backgroundActualizacion"></div>
  <p class="titulo">Actualiza tus datos</p>
  <p class="descripcion">
    Es importante que agregues tu cédula para que podamos generar y enviarte la facturación de tus recargas en nuestra plataforma. Mantén tus datos actualizados.
  </p>
  <img class="logoStreamyApp" src="../../../assets/logos/logo.png" alt="">

  <div class="contDiseno">
    <div class="conImg">
      <img class="fotoUser" src="{{userData.foto}}" alt="">
    </div>
    <p class="texto">{{userData.nombre}}</p>

    <div class="contformulario">
      <div class="input-field">
        <i><ion-icon class="iconoStilo" name="id-card-outline"></ion-icon></i>
        <input [(ngModel)]="cedula" name="valor" id="prueba" type="number" placeholder="Cedula" />
      </div>
    </div>  
  </div> 

  <div class="ContButton">
    <ion-button (click)="validaCampo()" class="addSaldo" >
      <p>Actualizar</p> 
    </ion-button>
    <ion-spinner *ngIf="cargando" name="crescent"></ion-spinner>
  </div>

</div>
